import {Poi} from '../../react-app-env';
import React from 'react';
import ListViewGroup from '../listview/listviewgroup/ListViewGroup';
import {i18n} from '../../i18n/i18n';
import ListViewItem from '../listview/listviewitem/ListViewItem';
import {PoiMetaData} from '../../services/MetaDataService';
import {delay} from '../../utils/Timing';
import {Events, EventType} from '../../events/Events';
import {DefaultItemDecorations} from '../listview/listviewitem/ListViewItem.types';

export interface LocationGroupProps {
  poi: Poi;
  metaData?: PoiMetaData | null;
  onRouteEffectClicked: () => void;
}

const LocationGroup: React.FunctionComponent<LocationGroupProps> = ({ poi, metaData, onRouteEffectClicked }) => {

  const [copyConfirmationVisible, setCopyConfirmationVisible] = React.useState(false);

  const formattedAddress = metaData?.address ?? (poi.location.lat + ', ' + poi.location.lng);

  /**
   * Copies the formatted address to the clipboard and shows a confirmation message.
   */
  async function copyFormattedAddressToClipboard() {
    await navigator.clipboard.writeText(formattedAddress);
    setCopyConfirmationVisible(true);
    delay(2500, () => setCopyConfirmationVisible(false));
  }

  let routeLabel = i18n().routeEffects.none.label;
  if (poi.routeEffect === 'CONTINUE') {
    routeLabel = i18n().routeEffects.continue.label;
  } else if (poi.routeEffect === 'RESTART') {
    routeLabel = i18n().routeEffects.restart.label;
  }

  return <ListViewGroup>
    <ListViewItem title={formattedAddress}
                  iconCategory="fa-map-pin"
                  decoration={DefaultItemDecorations.COPY}
                  confirmationMessage={copyConfirmationVisible ? i18n().poiDetails.location.copyAddressConfirmation : undefined}
                  onClick={() => copyFormattedAddressToClipboard()}/>
    <ListViewItem title={routeLabel}
                  iconCategory="fa-route"
                  decoration={DefaultItemDecorations.CHEVRON}
                  onClick={() => onRouteEffectClicked()}/>
    <ListViewItem title={i18n().poiDetails.location.centerInMap}
                  iconCategory="fa-bullseye"
                  onClick={() => Events.publish(EventType.CENTER_IN_MAP, poi.location)}/>
  </ListViewGroup>;
};

export default LocationGroup;
